import type { ReactNode } from 'react';
import styles from './Heading.module.css';

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export interface HeadingProps {
  level: HeadingLevel;
  /** Visual size override — use h2 tag but h3 visual size */
  as?: HeadingLevel;
  /** R1 color token name (default: n999) */
  color?: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
  children: ReactNode;
}

export function Heading({
  level,
  as,
  color = 'n999',
  align = 'left',
  className,
  children,
}: HeadingProps) {
  const Tag = `h${level}` as const;
  const visualLevel = as ?? level;

  return (
    <Tag
      data-crd-id="r2.bq-heading"
      data-crd-layer="r2"
      className={`${styles.heading} ${styles[`size${visualLevel}`]} ${className ?? ''}`}
      style={{
        color: `rgba(var(--bq-${color}), 1)`,
        textAlign: align,
      }}
    >
      {children}
    </Tag>
  );
}
